import { useQuery } from '@apollo/client';
import { getSiteBranding } from 'flows/core/components/onboarding/common/queries';
import type { SiteBranding, SiteBrandingInput } from '@updater/consumer-graph';

export interface SiteBrandingQueryData {
  siteBranding?: SiteBranding | null;
}

interface SiteBrandingQueryVariables {
  input: SiteBrandingInput;
}

export const useSiteBranding = ({
  inviteToken,
}: { inviteToken?: string } = {}) =>
  useQuery<SiteBrandingQueryData, SiteBrandingQueryVariables>(getSiteBranding, {
    variables: {
      input: {
        subdomain: null,
        inviteToken,
      },
    },
  });
